import { SVG, SVGProps } from './svg'

export function IconTriangleOutlineDown(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M11.2 21.6 1 4.4a.8.8 0 0 1 0-.8l.1-.2c.2-.3.4-.4.7-.4H22c.3 0 .5.1.7.4l.1.2c.1.2.1.5 0 .8L12.8 21.6c-.1.3-.4.4-.7.4h-.3a.8.8 0 0 1-.6-.4ZM12 19l8.2-14H3.8L12 19Z"
      />
    </SVG>
  )
}
